import React from 'react'

function Footer() {
  return (
    <div>
      <h6>&copy; CONNECTIONS</h6>
    </div>
  )
}

export default Footer

